import script from "./suggested-talking-point.vue?vue&type=script&setup=true&lang=ts"
export * from "./suggested-talking-point.vue?vue&type=script&setup=true&lang=ts"

import "./suggested-talking-point.vue?vue&type=style&index=0&id=29939f6c&lang=scss"

const __exports__ = script;

export default __exports__